import { render, staticRenderFns } from "./DisabledFactoryResetUsers.vue?vue&type=template&id=807b4fc2&"
import script from "./DisabledFactoryResetUsers.vue?vue&type=script&lang=js&"
export * from "./DisabledFactoryResetUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports